import React from 'react'

export const NavbarCss2 = () => {
  return (
    <nav className='nav-css nav-css2 background-nature'>
        <button href='#' >Home</button>
        <button href='#' >About</button>
        <button href='#' >Blog</button>
        <button href='#' >Portfolio</button>
        <button href='#' >Contact</button>
        <div className='animation animation2 start-home'></div>
    </nav>
  )
}
